import React, { Fragment } from "react";
import SEO from "../../components/SEO/SEO";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ContactInfoSection from "./ContactInfoSection";
import ContactForm from "../../components/ContactFrom/ContactForm";

// import background image
import contactBg from "../../images/contact/contact-form-consultation.webp";

const ContactPage: React.FC = () => {
  return (
    <Fragment>
      <SEO title="Contact Us" description="Get in touch with the AXOIX team. Email hello@axoix.com or fill out our contact form. We're based in New Delhi, India." path="/contact" />
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Contact AXOIX" pagesub="Contact" />
            <ContactInfoSection />
            <section className="contact">
              <div className="container">
                <div
                  className="xb-contact-wrap xb-border bg_img"
                  // style={{
                  //   backgroundImage: `url(${contactBg})`,
                  // }}
                >
                  <div className="xb-contact-form xb-main-contact xb-border">
                    <div className="form-heading text-center mb-30">
                      <h3 className="title">Get in Touch</h3>
                      <p className="sub-title clr-white">
                        Have a question, feedback, or need support? We're here to help.
                      </p>
                    </div>

                    <ContactForm/>
                  </div>

                  {/* Google Map Embed — Uttam Nagar, New Delhi */}
                  <div className="google-map">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.298772176999!2d77.03355555622551!3d28.620806342527402!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d05125146eecd%3A0xe1e9771496b7e3b5!2sAXOIX%20TECHNOLOGIES%20PVT.%20LTD.!5e0!3m2!1sen!2sin!4v1789114260197!5m2!1sen!2sin"
                      loading="lazy"
                      title="AXOIX Office - Uttam Nagar, New Delhi"
                      referrerPolicy="strict-origin-when-cross-origin"
                      style={{ width: "100%", height: "100%", border: 0 }}
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ContactPage;
